<template>
    <div class="postcard">

        <Image v-if="cover" :image="cover" :width="800" imageClass="cover" :key="cover.id" />
        <ExternalImage v-else-if="externalImage" :image="externalImage" imageClass="cover" :key="externalImage.url" />

        <div :class="`${titolo ? 'contentBox' : 'iconBox'}`">
            <div class="iconCont">
                <div :class="['icon', tipologia]">
                    <IconInstagram :size="22" v-if="tipologia == 'instagram'" />
                    <IconFacebook :size="22" v-else-if="tipologia == 'facebook'" />
                    <IconTikTok :size="18" v-else-if="tipologia == 'tiktok'" />
                    <IconTwitter :size="15" v-else-if="tipologia == 'twitter'" />
                    <IconYoutube :size="20" v-else-if="tipologia == 'youtube'" />
                    <IconLinkedIn :size="20" v-else-if="tipologia == 'linkedin'" />
                </div>
            </div>
            <div class="title4">{{ titolo }}</div>
        </div>

        <a v-if="link" class="overlink" :href="link" target="_blank"></a>
    </div>
</template>

<script lang="ts" setup>
interface Props {
    cover?: any,
    externalImage?: any,
    titolo?: string,
    tipologia?: string,
    link?: any
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.postcard {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: var(--color-background-image);
    border-radius: var(--size-card-radius);
    overflow: hidden;

    .iconCont {
        transform: translate3d(-10px, calc(0px - var(--margin-default) - 20px), 0);
        height: 0;

        .icon {
            height: 40px;
            width: 40px;
            border-radius: 20px;

            display: flex;
            justify-content: center;
            align-items: center;

            &.facebook {
                color: white;
                background-color: #1877F2;
            }

            &.instagram {
                color: white;
                background: #d6249f;
                background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
            }

            &.tiktok,
            &.twitter {
                color: white;
                background-color: #000000;
            }

            &.linkedin {
                color: white;
                background-color: #0077B5;
            }

            &.youtube {
                color: white;
                background-color: #FF0000;
            }
        }
    }

    .contentBox {
        background-color: var(--color-background-box);
        position: absolute;
        bottom: var(--margin-gap);
        left: var(--margin-gap);
        padding: var(--margin-default);

        border-radius: var(--size-card-radius-inner);
        max-width: calc(100% - (var(--margin-gap) * 2));
        box-sizing: border-box;

        .title4 {
            display: -webkit-box;
            line-clamp: 3;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

    .iconBox {
        position: absolute;
        bottom: var(--margin-default);
        left: var(--margin-default);

        .iconCont {
            transform: none;
            height: 40px;
        }
    }
}
</style>